export const SET_EVENT = 'SET_EVENT';
export const SET_EVENTS_LIST = 'SET_EVENTS_LIST';
export const ADD_OPENED_WINDOW = 'ADD_OPENED_WINDOW';
export const REMOVE_OPENED_WINDOW = 'REMOVE_OPENED_WINDOW';
export const REMOVE_OPENED_WINDOWS = 'REMOVE_OPENED_WINDOWS';
export const DEACTIVATE_EVENT = 'DEACTIVATE_EVENT';
export const DEACTIVATE_ALL_EVENTS = 'DEACTIVATE_ALL_EVENTS';
export const SET_CALL = 'SET_CALL';
export const SET_CALL_ACTIVE = 'SET_CALL_ACTIVE';
export const UPDATE_STATUS = 'UPDATE_STATUS';
export const UPDATE_STATUSBG = 'UPDATE_STATUSBG';
export const SET_EQUIPMENT_ONLINE = 'SET_EQUIPMENT_ONLINE';
export const ADD_WIDGET = 'ADD_WIDGET';
export const REMOVE_WIDGET = 'REMOVE_WIDGET';
export const SET_DOCK_ENABLED = 'SET_DOCK_ENABLED';
export const SET_WIDGET_HIDDEN = 'SET_WIDGET_HIDDEN';
export const SET_WIDGETS_ORDER = 'SET_WIDGETS_ORDER';
export const SET_COUNTERS_ENABLED = 'SET_COUNTERS_ENABLED';
export const DROP_CALL = 'DROP_CALL';
export const SET_EVENTS_HISTORY = 'SET_EVENTS_HISTORY';
export const CLEAR_EVENTS_HISTORY = 'CLEAR_EVENTS_HISTORY';
export const PLAY_SOUND = 'PLAY_SOUND';
export const STOP_SOUND = 'STOP_SOUND';
export const SET_PAYMENT_MEAN_INFO = 'SET_PAYMENT_MEAN_INFO';
export const SET_BOARDS_DATA = 'SET_BOARDS_DATA';
export const CLEAR_PAYMENT_MEAN_INFO = 'CLEAR_PAYMENT_MEAN_INFO';
export const SET_EVENT_UNRECOGNIZED = 'SET_EVENT_UNRECOGNIZED';
export const SET_COUNTERS = 'SET_COUNTERS';
export const SET_ONETIME = 'SET_ONETIME';
export const SET_REGULAR = 'SET_REGULAR';
